import { application } from "./application"

import FrameFallbackController from "./frame_fallback_controller"
application.register("frame-fallback", FrameFallbackController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)
